import { createFileRoute } from "@tanstack/react-router"
import { ErpSettingsCard } from "~/components/settings/erp/ErpSettingsCard"

export const Route = createFileRoute("/_auth/settings/_layout/erp")({
  component: ErpSettingsCard,
})
